function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useContainer } from '@bydesign-ui/hooks';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { useEffect } from 'react';
import { Draggable } from '../../../models/draggable';
export function useDynamicDraggable(target, options) {
  var onDragPrepare = options.onDragPrepare,
      onDragStart = options.onDragStart,
      onDragging = options.onDragging,
      onDragEnd = options.onDragEnd,
      onScrollStart = options.onScrollStart,
      onScrollEnd = options.onScrollEnd,
      onBeforeCreateActionEle = options.onBeforeCreateActionEle,
      extra = _objectWithoutProperties(options, ["onDragPrepare", "onDragStart", "onDragging", "onDragEnd", "onScrollStart", "onScrollEnd", "onBeforeCreateActionEle"]);

  var draggable = useSingleton(function () {
    return new Draggable();
  });
  var container = useContainer(target);
  var handleDragPrepare = useRefCallback(onDragPrepare);
  var handleDragStart = useRefCallback(onDragStart);
  var handleDragging = useRefCallback(onDragging);
  var handleDragEnd = useRefCallback(onDragEnd);
  var handleScrollStart = useRefCallback(onScrollStart);
  var handleScrollEnd = useRefCallback(onScrollEnd);
  var handleBeforeCreateActionEle = useRefCallback(onBeforeCreateActionEle);
  draggable.updateDraggableOptions(extra);
  useEffect(function () {
    var elem = container();

    if (elem) {
      draggable.updateTarget(elem);
    }
  }, [container()]);
  useEffect(function () {
    draggable.addListener('drag-prepare', handleDragPrepare);
    draggable.addListener('drag-start', handleDragStart);
    draggable.addListener('dragging', handleDragging);
    draggable.addListener('drag-end', handleDragEnd);
    draggable.addListener('scroll-start', handleScrollStart);
    draggable.addListener('scroll-end', handleScrollEnd);
    draggable.addListener('before-create-action-ele', handleBeforeCreateActionEle);
    return function () {
      draggable.removeListener('drag-prepare', handleDragPrepare);
      draggable.removeListener('drag-start', handleDragStart);
      draggable.removeListener('dragging', handleDragging);
      draggable.removeListener('drag-end', handleDragEnd);
      draggable.removeListener('scroll-start', handleScrollStart);
      draggable.removeListener('scroll-end', handleScrollEnd);
      draggable.removeListener('before-create-action-ele', handleBeforeCreateActionEle);
      draggable.dispose();
    };
  }, []);
  return draggable;
}